import Hero from './sections/Hero';
import Stats from './sections/Stats';
import TrustedBy from './sections/TrustedBy';
import MeetAndy from './sections/MeetAndy';
import Podcast from './sections/Podcast';
import EverythingYouNeed from './sections/EverythingYouNeed';
import Canvas from './sections/Canvas';
import HowItWorks from './sections/HowItWorks';
import CTA from './sections/CTA';

const Index = () => {
  return (
    <>
      <Hero />
      <Stats />
      <TrustedBy />
      <MeetAndy />
      <Podcast />
      <EverythingYouNeed />
      <Canvas />
      <HowItWorks />
      <CTA />
    </>
  );
};

export default Index;
